<style>

.space{
  margin: 150px 20px 20px 20px;
}

</style>

<Auth bind:this="{auth}"></Auth>

{#if message == "invalid"}

<div class="center space">
  <p>We're sorry, that code was invalid.</p>
  <p>You might want to ask the person that sent you this code to send you another one.</p>
  <p><button on:click="{ () => document.location = 'http://192.168.1.197:5001' }">Go Home</button></p>
</div>
  
{:else}
  <div class="center space">
    <Spinner spin="{false}"></Spinner>
    <!-- <Spinner></Spinner> -->
    <h3>Loading...</h3>
  </div>
{/if}

<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Auth from "../interfaces/Auth.svelte";
let auth;

import Spinner from "../components/Spinner.svelte";

let message = "";
let code = "";

import { onMount } from "svelte";
onMount(async () => {
  validateCode();
});

async function validateCode() {
  
  // console.log("params:", params);
  code = params.code;
  
  // console.log("code:", code);
  
  // if (code == null || code == "") document.location = "/";
  
  try {
    
    let res = await auth.post("validateCode", {code: code}, false);
    
    if (res == "+") {
      localStorage.setItem("vc", code);
      localStorage.setItem("v", true);
    } else {
      localStorage.setItem("vc", "");
      localStorage.setItem("v", false);
    }
    document.location = "/";
    
  } catch (error) {
    console.log("error:", error);
    message = "invalid";
  }
  
}


</script>